"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TailwindPreset = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./lib/button.styles"), exports);
tslib_1.__exportStar(require("./lib/form-description.styles"), exports);
tslib_1.__exportStar(require("./lib/form-error.styles"), exports);
tslib_1.__exportStar(require("./lib/toast.styles"), exports);
tslib_1.__exportStar(require("./lib/form-field.styles"), exports);
tslib_1.__exportStar(require("./lib/modal.styles"), exports);
tslib_1.__exportStar(require("./lib/input-label.styles"), exports);
tslib_1.__exportStar(require("./lib/input.styles"), exports);
tslib_1.__exportStar(require("./lib/tooltip.styles"), exports);
tslib_1.__exportStar(require("./lib/divider.styles"), exports);
tslib_1.__exportStar(require("./lib/checkbox.styles"), exports);
tslib_1.__exportStar(require("./lib/label.styles"), exports);
tslib_1.__exportStar(require("./lib/card.styles"), exports);
tslib_1.__exportStar(require("./lib/accordion.styles"), exports);
tslib_1.__exportStar(require("./utils/tw"), exports);
var tailwind_preset_1 = require("./lib/tailwind.preset");
Object.defineProperty(exports, "TailwindPreset", {
  enumerable: true,
  get: function () {
    return tailwind_preset_1.default;
  }
});
